import apiClient from "../../axios/apiClient";


export const getJobList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_JOBLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Job`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_JOBLIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_JOBLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveJobData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_JOB_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Job`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_JOB_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_JOB_REJECTED", payload: error.response });
    }
  };
  

  export const getJobListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_JOBLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Job/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_JOBLISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_JOBLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateJobData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_JOB_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Job/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_JOB_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_JOB_REJECTED", payload: error.response });
  }
};


export const updateJobStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_JOB_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Job-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_JOB_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_JOB_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteJobData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_JOB_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Job/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_JOB_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_JOB_REJECTED", payload: error.response });
  }
};